export const ACTION_TYPES = {
  ADD: "add",
  REMOVE: "remove",
};

export const ITEM_TYPE = {
  CATALOG: "catalog",
};
